"use client";
import { jsx as C } from "react/jsx-runtime";
import { memo as i, forwardRef as n } from "react";
import { useSvgIcon as e } from "../useSvgIcon.js";
const m = i(
  n((o, r) => {
    const t = e({
      ...o,
      ref: r
    });
    return /* @__PURE__ */ C(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t(),
        children: /* @__PURE__ */ C(
          "path",
          {
            d: "M25.7644 7.41625C25.562 7.31159 25.3648 7.19687 25.1738 7.0725C24.6184 6.70528 24.1091 6.27259 23.6569 5.78375C22.5257 4.48938 22.1032 3.17625 21.9476 2.25688H21.9538C21.8238 1.49375 21.8776 1 21.8857 1H16.7332V20.9237C16.7332 21.1912 16.7332 21.4556 16.7219 21.7169C16.7219 21.7494 16.7188 21.7794 16.7169 21.8144C16.7169 21.8288 16.7169 21.8438 16.7138 21.8587C16.7138 21.8625 16.7138 21.8663 16.7138 21.87C16.6595 22.5849 16.4304 23.2754 16.0465 23.8809C15.6627 24.4864 15.1359 24.9884 14.5126 25.3425C13.8629 25.7121 13.1281 25.906 12.3807 25.905C9.98007 25.905 8.03444 23.9475 8.03444 21.53C8.03444 19.1125 9.98007 17.155 12.3807 17.155C12.8351 17.1546 13.2868 17.2261 13.7188 17.3669L13.7251 12.1206C12.4134 11.9512 11.0809 12.0554 9.81155 12.4268C8.54221 12.7981 7.3636 13.4285 6.35007 14.2781C5.46199 15.0498 4.71537 15.9704 4.14382 16.9988C3.92632 17.3738 3.10569 18.8806 3.00632 21.3263C2.94382 22.7144 3.36069 24.1525 3.55944 24.7469V24.7594C3.68444 25.1094 4.16882 26.3037 4.95819 27.3106C5.59472 28.1183 6.34675 28.8278 7.19007 29.4163V29.4037L7.20257 29.4163C9.69694 31.1112 12.4626 31 12.4626 31C12.9413 30.9806 14.5451 31 16.3663 30.1369C18.3863 29.18 19.5363 27.7544 19.5363 27.7544C20.271 26.9025 20.8552 25.9318 21.2638 24.8838C21.7301 23.6581 21.8857 22.1881 21.8857 21.6006V11.0306C21.9482 11.0681 22.7807 11.6187 22.7807 11.6187C22.7807 11.6187 23.9801 12.3875 25.8513 12.8881C27.1938 13.2444 29.0026 13.3194 29.0026 13.3194V8.20438C28.3688 8.27313 27.0819 8.07313 25.7644 7.41625Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
m.displayName = "IconTiktok";
export {
  m as IconTiktok
};
